import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, fmtDateTime } from "@/components/common";
import DataTable from "@/components/DataTable";

export default function AuditLog() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  const columns = [
    { key: "user_name", label: "User" },
    { key: "action", label: "Action", render: (r) => <span className="font-medium text-slate-800">{r.action}</span> },
    { key: "entity", label: "Entity" },
    { key: "old_value", label: "From", render: (r) => <span className="text-xs text-slate-500">{r.old_value != null ? String(r.old_value) : "—"}</span> },
    { key: "new_value", label: "To", render: (r) => <span className="text-xs text-slate-700">{r.new_value != null ? String(r.new_value) : "—"}</span> },
    { key: "ip", label: "IP", render: (r) => <span className="text-xs font-mono">{r.ip || "—"}</span> },
    { key: "created_at", label: "Time", render: (r) => <span className="text-xs">{fmtDateTime(r.created_at)}</span> },
  ];
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Every important action is recorded" testid="audit-header" />
      <DataTable columns={columns} rows={rows} loading={rows === null} testid="audit-table" empty="No audit entries yet" />
    </div>
  );
}
